module.exports = __webpack_public_path__ + "media/country_flags/td-5e003ad1.png";